/**
 * Shared formatting utilities for MetricCard last-values displays.
 * Used by ClientV2Page/LastValuesMetrics and LuminaireDashboardPage/LuminaireLastValuesMetrics.
 */

export type MetricPoint = { Value?: number | string; Time?: string }

export const lastPoint = (data: unknown): MetricPoint | undefined => {
  if (!Array.isArray(data) || data.length === 0) return undefined
  return data[data.length - 1] as MetricPoint
}

export const formatMetricValue = (
  value: number | string | undefined,
  decimals: number = 2
): string => {
  if (value === undefined || value === null) return 'NA'
  if (typeof value === 'string') return value
  return Number(value).toFixed(decimals)
}

export const formatMetricDate = (dateString: string | undefined): string => {
  if (!dateString) return 'Date inconnue'
  try {
    return new Date(dateString).toLocaleString('fr-FR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })
  } catch {
    return 'Date invalide'
  }
}
